<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>打功能</span>
      </div>

      <el-form>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>基本配置</span>
              </div>
              <el-form :inline="true">
                <el-form-item label="消耗BET">
                  <el-input v-model.number="basic.bet" placeholder="消耗BET" />
                </el-form-item>
                <el-form-item label="打睡眠时长(秒)">
                  <el-input v-model.number="basic.sleep" placeholder="打睡眠时长(秒)" />
                </el-form-item>
                <el-form-item label="时间范围">
                  <el-time-select
                    v-model="basic.run.start"
                    :picker-options="{
                      start: '00:00',
                      step: '00:15',
                      end: '23:45'
                    }"
                    placeholder="选择时间"
                  />
                </el-form-item>
                <el-form-item label="-">
                  <el-time-select
                    v-model="basic.run.end"
                    :picker-options="{
                      start: '00:00',
                      step: '00:15',
                      end: '23:45'
                    }"
                    placeholder="选择时间"
                  />
                </el-form-item>
              </el-form>
            </el-card>
          </el-col>

          <el-col :span="24" class="mtop">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>打判断</span>
              </div>
              <el-form :inline="true">
                <el-form-item label="建筑未破损数量">
                  <el-input v-model.number="basic.attack.buildNum" placeholder="未破损数量" />
                  <!--                  <el-tooltip class="item" effect="dark" content="机器人根据好友当前未破损建筑数量[大于等于N]" placement="top-start">-->
                  <!--                    <i class="el-icon-warning-outline" />-->
                  <!--                  </el-tooltip>-->
                </el-form-item>
                <el-form-item label="最低关卡等级">
                  <el-input v-model.number="basic.attack.buildLevel" placeholder="最低关卡等级" />
                  <!--                  <el-tooltip class="item" effect="dark" content="等级大于N级" placement="top-start">-->
                  <!--                    <i class="el-icon-warning-outline" />-->
                  <!--                  </el-tooltip>-->
                </el-form-item>
                <el-form-item label="机器人打同一个用户次数(天)">
                  <el-input v-model.number="basic.attack.maxNum" placeholder="当天一个机器人打同一个好友次数" />
                  <!--                  <el-tooltip class="item" effect="dark" content="当天一个机器人打同一个好友次数" placement="top-start">-->
                  <!--                    <i class="el-icon-warning-outline" />-->
                  <!--                  </el-tooltip>-->
                </el-form-item>
                <el-form-item label="单个好友被打冷却时间(秒)">
                  <el-input v-model.number="basic.attack.coolDown" placeholder="单个好友被打冷却时间" />
                </el-form-item>
              </el-form>
            </el-card>
          </el-col>
        </el-row>
        <el-button class="mtop" type="primary" @click="onSubmit()">保存</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'RobotSlot',
  data() {
    return {
      key: 'ROBOT_FRIEND_CONFIG:SLOT',
      basic: {
        bet: 1,
        sleep: 30,
        attack: {
          buildNum: 0,
          buildLevel: 0,
          maxNum: 0,
          coolDown: 300
        },
        run: {
          start: '',
          end: ''
        }
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    getTables() {
      getCommonCfg({ name: this.key }).then(res => {
        this.basic = res.data
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.basic)
      updateCommonCfg({ data: data, name: this.key }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 20px;
}
</style>
